/*
 * @Author: shen
 * @Date: 2021-07-18 12:25:49
 * @LastEditors: shen
 * @LastEditTime: 2021-07-18 12:28:58
 * @Description:
 */
export default {
  state: {},
  mutation: {},
  actions: {},
}
